import { render } from "./ListeApprovisionnement.vue?vue&type=template&id=61353e00&ts=true"
import script from "./ListeApprovisionnement.vue?vue&type=script&lang=ts"
export * from "./ListeApprovisionnement.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__